import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCloud2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="cloud-2"><path d="M9.9502 3.60986C11.6659 3.60993 13.2067 4.34835 14.2793 5.51904C14.6181 5.44382 14.9701 5.40384 15.3311 5.40381C18.0096 5.40381 20.1816 7.57581 20.1816 10.2544C20.1816 10.4075 20.1713 10.5585 20.1572 10.7075C21.8334 11.4707 23 13.1592 23 15.1226C22.9999 17.7173 20.9624 19.8362 18.3994 19.9663L18.3887 19.9673H18.3789L18.168 19.9722H6.875C3.63033 19.9722 1 17.3418 1 14.0972C1.00008 11.8533 2.25827 9.90562 4.10449 8.9165C4.39039 5.93864 6.89708 3.60986 9.9502 3.60986Z" fill="currentColor"/></CentralIconBase>;
};

export default IconCloud2;
